import React from 'react'

import { Button, SocialFacebook, SocialGoogle } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func } from 'prop-types'

function SocialButtons({ onSocial: handleSocial }) {
  return (
    <div className="ai-sign-in-modal__socials">
      <Button
        type="secondary"
        size="medium"
        variant="with-icon"
        icon={<SocialGoogle width="20" height="20" />}
        customClass="ai-sign-in-modal__social"
        onClick={() => handleSocial('google')}
      >
        Google
      </Button>
      <Button
        type="secondary"
        size="medium"
        variant="with-icon"
        icon={<SocialFacebook width="20" height="20" />}
        customClass="ai-sign-in-modal__social"
        onClick={() => handleSocial('facebook')}
      >
        Facebook
      </Button>
    </div>
  )
}

SocialButtons.propTypes = {
  onSocial: func.isRequired,
}

export default SocialButtons
